export default "__VITE_ASSET__5gcq5el_hCCFrIB2p2yjiQ__"